import { Menu } from "@headlessui/react";

import { JSX } from "react";
import { useTranslation } from "react-i18next";

import { IconLockProfile } from "@/components/icons";
import { MODAL_ROUTES } from "@/components/modals/router/ModalRoutes";

import { Profile } from "@/api/auth/auth.types";
import { useJwtCreate } from "@/hooks/api/login.hooks";
import useModalRouter from "@/hooks/useModalRouter";
import { cn } from "@/utils/cn.ts";

const HeaderProfileProfiles = ({ data }: { data: Profile[] }): JSX.Element => {
  return <ul>{data?.map((e) => <MenuButton key={e.id} data={e} />)}</ul>;
};

export default HeaderProfileProfiles;

const MenuButton = ({ data }: { data: Profile }) => {
  const { mutate } = useJwtCreate({ profileId: data?.id?.toString() });
  const { t, i18n } = useTranslation();
  const { openModal } = useModalRouter();

  const image =
    i18n.language === "ru"
      ? "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAD4AAAAeCAYAAAB0ba1yAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAPgSURBVHgB7Vg9TNtAFH5B2UBqJjpi2PszwoSrsnUIXVkwlcoKHZEq4UhIHaFdOzQMsDbsIMLGVgp7MSMsuBLM7vt8d7lL4rMPA1Ko8knn2Hfvft697713F6IhhhhiiP8QlazKJEm2+KdO5dCuVCpLNOCoWuo9Wcpgkp4AbIo/S58b74n+nJATXvpEqz/oqaCa23obE11F5IRLR7kBgU1xQVdTmbmgXwrtZ20qAscMn3/mSTGJ6C8XUKnFpcbFp4dBzPGlJeecl2P3osUycdVlNBqtZdP47Ihozbd2kwqjo2cRWecS0cMpHnFp8byBnNcm07YpPpE+Fc3HOhvH3Kc92e5TDnhyKBWmH2DGwbYeDxs5zQZ5MeuR2pSUPUfkhJm6GGN/W69vuq7m9UhsKNExL/Um7u4j4WbxcU+9/WaaBNKSvk1ctofpx26DS9gvtLcl3OfjplgQXGbLMQs+P+RN81k+kN9eR3E5r5cG5Y35/j4S1YxFe+nL/YKVoJmpNJSbkQs5bQvr7zeFRT7/FFbTGywC622s+47WHKY10jAyUg7cfVwgdpCeTZ/YOKU0LPLlUCsGhdbeiFR53BLWBvWnDQuZm7bM7Hi7SM5A34JsNJJR56XPqwtdo338mlxhRvuFsNua2EhQXAG+KBBT/uai7YLyYG54Dkvu6uMX5AqtjFiMCkRZ0JvEgmnwXLdIfuIY02R3TMgGMAlA/IDUQTNTLEtxL33eurA6B2b/rOCWLevkyFYoisPSC7x3Ow2rqF1xM7hNvVZvEbnCpFl9NT846bYalVXepDiUNl0rA6niMpIHsk5EEdNHxyfU26yU9agIpqJINUYqyUGRj9uhKI5Aio0ugLI4Sxt+hd07bumBtMUDcgUODMq/4O+9imMOlbfRtpBOX05pk53IHg6o9g2AExbyqwIos9sonhC+BTlYur4ilEFf1OOwgvq5RVGHE9r3VX3z0/cARMDyfu5AcYVuxZHCegMRKO9wEen4WEq1FaEoDiagIIIX2rKCHGipczRoFlAZYF6kTYE2FRypR+gxARf59ivbv1Uu1/m8wakqorLQFP9KrmkXZ2vkxuS0nSTvSJSdMLkTljzR74Onaq65nHfab/jz9FCUy/Pe3qvGWvImDqSMDedcalyaOTI+xnA7wJQD7saTcrHrbGGvx/IIZLiOhSx3Qg8DsCZOcs43Ci6KY7DQ1siTRKSusRnASYt/YAEELZUeIhut5Vwh5YBlKgXtARXEim7Fp17pPxx0CnPD8qa4aY3VbIuBhds0SEiUj2cjLOgb2fyNBhjK4vAx278ARf6HwJRl5nse9h8X/wBELEpIwaKCugAAAABJRU5ErkJggg=="
      : "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAE8AAAAeCAYAAABt5kPUAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAUrSURBVHgB7Vk9bBNJFH4+uctJbEXKM9dz+Lp0FwQ1JG2a7BW0xC6RkLKRQJQxlEQiTkNLQg2KqaALPzXxUpIGRwr18r6Zed7Z9e7seEOQkPaTxmvPz/ubN++9WRM1aNCgQYMGHmjhI0mSDj8OPdfE3D5wG7RarZhqgnmCX6dojOleIX86A37cLhleZVrv6SIB4yX1sE01wWvjMqJz0hk65FumC0Q78+trTHTvunvFYofoZkh0Yx2/eixgwLv7P9UF+IEv8GxMtbHTJ3q7r7/ff0H0d5cuGu2ZnpPYvQLjn0ZEzyOiJ0dEC0HIBtxjA46oDmC4Kp4+OJukdL5P6FegXTqyEHAk6WX7oOjrYfr94DHR2iZ+4WMk08xxWeF2yXSdckPsGc0TJ+HV/Ai5XbO6Tw2d/TnpQJ5umUw8p2vGiyDrvpj5I3SWG+/PQAyTxdX/OFWYU3owkDldIyQERBzsULkiETPfIgeMsiDcK5mygZjJTycdQ6tnaAWOORHp5LlJ1djk+ddhwLbHZJyBx7JQxTsxXno8AiYIxpH6dcwb+ukN0dgkOnjx1WWiJZUUI2PkSw6eyMTaC0Dn3X7K63KHY+46nvyFdo18ZdgupQOZlla0M2i5J1PZjz/oOf/wGNLX6z0dEuAo4G/gYzwAHDrqmwR3IBuUI/WJwA2PzAN9SDaPDiFAVTTvTpNXUTxEvF2LxOsDJx0Y68GqjtNFMmFTkWAWAk3n3YGmD4DHq2Eqw431jPH+oGqA6DLBeBBkYCXW/LF+vpU1nPK2lZShGMQnoNuGAx14PGhNeUU65lbhaT81HLxN6IhMGINxiwBdHMms3POQveyyxc6K8Lg721ope1x2DELCw8QzMfZwVR+JbKIpBnZfeEHZ3m46BmVFrpes3O2NcjrYJElw8HpdHaQy3f1XzwFNPBeC2fXQEzJgLLfpbSfjIlcXIC7YxntpeQGYacPFqi12lpUQojQUchnvyjVtfCBfr9k8fSB04Gm2cWBM0BYdv5/OGg962BVHbtxdqtzJXSBOvugYoIJqTxsBwmHu8ft03tL0toQzjoExKx0oBeBRyouZ1uW/inlDMTThiY3CZp55HPe8DmJsrAcd8Bc6dvwuQhrftji7ItGFpEsnBXepcjOc7YfHwIOwYzCYHEFbkMXp1TRmphNTVnQVzRPyAzIjaLu83weQcadfj45soD5BuHMP+TGUTt9SpW++w6VWlCuLMLbH/SzAu+3EBO+BIuIJElurkE9QQgceiWZn0hrwLVUEpzM9IhjihwgCg+ojiWKWiyRTa9mGLjuygB0/EeTzcc/XeMj+Ih9Ox1puHRzgHMbzLVV2TVNvA9SOCSSI2oE8LVcQbY9m1lQFfdvIecPN4+m2YfI84ZVVMa8C7lLl1V62D7uIWGTHDykVUPXDIyRL49jd6unYCcPZ9V9RLLUBRYUHvEd4IOBvV6y1YWdTxE85+rht7PTO/ULCXaoMQnICR0F2VGo7iTEwmO1t9hr9OqscGJ8aL8oeU+Hno/itDS2DbDqaAIa0N6kGfI5tFupuGWpDpTEECSVWO40YVXQsMdYfzsadIkhhbF2F1ObA8LhK+SK9Dmb7IV9Rfx2c403yN3PJFxrj6cgZD3081O3rOL8GL1HjCroan490O/uW1JQvlac+nfBnGQ9KjxJtgKCAFvrHSbEig0T/X+J8DW/kcb1e90Vo6IyTWVnmolNktxZdEBJtWEmVcd0/ixL9klJozHnFyNDpkK4cJuf546pBgwa/NX4AadWf4ILhIqUAAAAASUVORK5CYII=";

  const handleClick = () => {
    if (data.is_lock) {
      openModal(MODAL_ROUTES.PROFILE_PIN, { profile_id: data.id.toString() });
    } else {
      mutate(
        { profile_id: data.id.toString() },
        {
          onSuccess: () => {},
        },
      );
    }
  };

  return (
    <>
      <Menu.Item key={data.id}>
        {({ active }) => (
          <button
            type={"button"}
            onClick={handleClick}
            className={cn("responsive-transition flex w-full items-center justify-between px-4 py-1", {
              "bg-surface-container-high": active,
            })}
          >
            <span className={"flex items-center gap-3"}>
              <span className={"relative"}>
                <img
                  src={data.picture?.resized || "/images/anonymous.png"}
                  style={{ background: data.picture?.color || "#FF4B00" }}
                  alt={data.name}
                  loading={"lazy"}
                  className={"h-10 w-10 rounded-full object-cover object-center"}
                />
                {data.is_kids && (
                  <img
                    src={image}
                    alt={t("Profile.kids")}
                    className={cn("absolute -right-3 bottom-0 w-8", {
                      "h-4": i18n.language === "ru",
                      "h-3": i18n.language === "uz",
                    })}
                  />
                )}
              </span>
              <span className="text-[16px]/[24px]">{data.name}</span>
            </span>
            {data.is_lock && <IconLockProfile className="size-5 stroke-on-surface" />}
          </button>
        )}
      </Menu.Item>
    </>
  );
};
